import store from '@ps/store'
import config from '@ps/store/workbench/storyboard/config'
import { updateLanguageByDevice } from '@ps/workbench/language'

type DeviceActionValueItem = {
  orientation: number
  changeOrientationForCaptureSceneImage: boolean
}

export type DeviceActionValue = {
  newValue: DeviceActionValueItem
  oldValue: DeviceActionValueItem
}

export type ResolutionType = {
  value: number
  label: string
  width: number
  height: number
  scaleX: number
  scaleY: number
}

export const getDeviceAction = (value: DeviceActionValue) => {
  const getWidthHeight = ({
    orientation,
    resolution,
  }: {
    orientation: number
    resolution: ResolutionType
  }) => {
    const width = orientation === 1 ? resolution.width : resolution.height
    const height = orientation === 1 ? resolution.height : resolution.width
    return {
      width,
      height,
    }
  }

  const update = ({
    orientation,
    changeOrientationForCaptureSceneImage,
  }: DeviceActionValueItem) => {
    const deviceState = store.state.workspace.game.device
    const { width, height } = getWidthHeight({
      orientation: orientation,
      resolution: deviceState.resolutionList.find(
        (item: ResolutionType) => item.value === deviceState.resolution,
      ),
    })
    deviceState.orientation = orientation
    deviceState.width = width
    deviceState.height = height
    store.commit('workspace/game/device/updateAdapterResolution', {
      screenResolution: deviceState.resolution,
      deviceRotate: deviceState.orientation,
    })

    // 切换横竖屏时并且渲染完毕后，更新一下 offerTop 的值
    setTimeout(() => {
      updateLanguageByDevice(deviceState.adapterResolution)
    })

    // 切换横竖屏的时候先隐藏iframe，保证在故事板视图下切换时效果好一点
    if (store.state.workspace.storyboard.mode === config.modeTypes.story) {
      store.commit('workspace/storyboard/hideFlow')
    }
    // 延迟 200 毫秒，等layout计算完成
    setTimeout(async () => {
      // 切换横竖屏时，主动更新当前节点，（因为切换横竖屏时，游戏layout逻辑更新宽、高、anchoredX、anchoredY不会触发这些值的setter）
      // 主动触发一次当前节点，保证编辑器与游戏界面的值再做一次同步
      store.dispatch('workspace/game/updateActiveNodeList', {
        nodes: store.state.workspace.game.activeNodeList,
      })
      // 补充截图，如在故事板视图中，竖屏编辑的元素，则需要补充横屏的截图
      await store.dispatch('workspace/sceneManager/updateCaptureThumbnail')
      // 如果是为了截图切换横竖屏的话，不触发故事板的横竖屏切换
      if (!changeOrientationForCaptureSceneImage) {
        store.dispatch('workspace/storyboard/changeOrientation')
      }
    }, 200)
  }

  return {
    execute: ({ newValue }: DeviceActionValue) => {
      update(newValue)
    },
    undo: ({ oldValue }: DeviceActionValue) => {
      update(oldValue)
    },
    value,
    methodName: 'getDeviceAction',
  }
}
